import {useEffect, useState} from 'react'
import styles from './index.module.scss'
interface TabProps {
  label: string
  value: string | number
}
interface TabsProps {
  list: TabProps[]
  defaultValue?: string
  onChange?: (data: TabProps) => void
}

export const Tabs = (props: TabsProps) => {
  const [selected, setSelected] = useState<string | number>('')
  useEffect(() => {
    if (props.defaultValue) {
      setSelected(props.defaultValue)
    }
  }, [props.defaultValue])
  const data = [
    {
      label: '上月',
      value: 'lastMonth',
    },
    {
      label: '昨日',
      value: 'lastDay',
    },
    {
      label: '今日',
      value: 'today',
    },
    {
      label: '本周',
      value: 'week',
    },
  ]
  const handleClick = (tab: TabProps) => {
    setSelected(tab.value)
    props.onChange && props.onChange(tab)
  }
  return (
    <div className={styles.tabsContainer}>
      {props.list.map((item: TabProps, index: number) => {
        return (
          <div
            onClick={() => {
              handleClick(item)
            }}
            key={index}
            className={`${styles.tab} ${selected === item.value && styles.tabActive} ${props.list[index + 1] && props.list[index + 1].value === selected && styles.noBorder}`}
          >
            {item.label}
          </div>
        )
      })}
    </div>
  )
}
export default Tabs
